import { render, staticRenderFns } from "./ProtoIcon.vue?vue&type=template&id=e850757e&scoped=true&"
import script from "./ProtoIcon.vue?vue&type=script&lang=js&"
export * from "./ProtoIcon.vue?vue&type=script&lang=js&"
import style0 from "./ProtoIcon.vue?vue&type=style&index=0&id=e850757e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e850757e",
  null
  
)

export default component.exports